/*eslint react-hooks/exhaustive-deps: "off"*/
import React, { useCallback, useContext, useEffect, useState } from "react";
import { Button, Form, Select, Typography } from "antd";
import { Title } from "./Common";
import { getApiHost } from "../../../utils";
import Axios from "axios";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faFileExcel } from "@fortawesome/free-solid-svg-icons";
import MapPropsContext from "../MapPropsContext";
import { StyledButton } from "../../../styled-components/Button";
import {
  TI_HIGHWAY_COMBO_BOX,
  TI_RAW_EXCEL_DOWN_BUTTON,
  TI_TABLE_EXCEL_DOWN_BUTTON,
} from "../../../Constants";

const { Text } = Typography;

const WidgetRadioHighway = ({
  setSelectedHighway,
  serviceName,
  setRadioChannelDataForHighway,
  disabled,
}) => {
  const { widgetState } = useContext(MapPropsContext);
  const { road_no } = widgetState;

  const [roadNo, setRoadNo] = useState("1");

  useEffect(() => {
    const url = getApiHost() + "/gis/radioServiceRoadPathList.json";
    const formData = new FormData();
    formData.append("service_nm", encodeURI(serviceName));
    formData.append("road_no", roadNo);

    Axios.post(url, formData)
      .then(({ data }) => {
        const { rows } = data;
        setRadioChannelDataForHighway(rows);
      })
      .catch((reason) => console.error(reason));

    setSelectedHighway(OPTIONS[roadNo]);
  }, [serviceName, roadNo]);

  const downloadXlsx = useCallback(
    (roadNo) => {
      const fileNm = roadNo === "50" ? "Y" : "B";
      // const hostUrl = 'http://spectrummap.kr/ridioExcelFileDown.do?fileNm=' + fileNm;
      const hostUrl = getApiHost() + "/ridioExcelFileDown.do?fileNm=" + fileNm;
      window.location.assign(hostUrl);
    },
    [roadNo]
  );

  const downloadXlsxLevel = useCallback(
    (fileNm) => {
      // const hostUrl = 'http://spectrummap.kr/ridioExcelFileDown.do?fileNm=' + fileNm;
      const hostUrl = getApiHost() + "/ridioExcelFileDown.do?fileNm=" + fileNm;
      window.location.assign(hostUrl);
    },
    [roadNo]
  );

  return (
    <Form.Item>
      <Title>경로검색</Title>
      <Select
        aria-label="경로검색"
        placeholder="고속도로"
        style={{ width: "100%" }}
        defaultValue={OPTIONS[road_no]}
        onChange={(e) => {
          console.log(OPTIONS[e]);
          setRoadNo(e);
        }}
        size={"small"}
        disabled={disabled}
        tabIndex={TI_HIGHWAY_COMBO_BOX}
      >
        {Object.entries(OPTIONS).map(([value, label]) => (
          <Select.Option value={value} key={value}>
            {label}
          </Select.Option>
        ))}
      </Select>
      {(roadNo === "1" || roadNo === "50") && (
        <div style={{ marginLeft: 2 }} class={"widget-radiohighway-r"}>
          <Text>FM 전파수신레벨 측정 RAW데이터</Text>
          <StyledButton
            isActive
            onClick={() => downloadXlsx(roadNo)}
            style={{ marginRight: 8 }}
            type="primary"
            tabIndex={TI_RAW_EXCEL_DOWN_BUTTON}
          >
            <FontAwesomeIcon icon={faFileExcel} />
            <span style={{ marginLeft: 8 }}>엑셀 다운로드</span>
          </StyledButton>
          <br />
          <Text>FM 전파수신레벨 측정 테이블 정보</Text>
          <StyledButton
            isActive
            onClick={() => downloadXlsxLevel("tab")}
            style={{ marginRight: 8 }}
            type="primary"
            tabIndex={TI_TABLE_EXCEL_DOWN_BUTTON}
          >
            <FontAwesomeIcon icon={faFileExcel} />
            <span style={{ marginLeft: 8 }}>엑셀 다운로드</span>
          </StyledButton>
        </div>
      )}
    </Form.Item>
  );
};

const OPTIONS = {
  1: "경부고속도로",
  12: "광주대구고속도로",
  10: "남해고속도로",
  30: "당진대전고속도로",
  15: "서해안고속도로",
  50: "영동고속도로",
  7: "일반국도7호선",
  35: "중부고속도로",
  45: "중부내륙고속도로",
  55: "중앙고속도로",
  25: "호남고속도로",
};

export default WidgetRadioHighway;
